import Controller from "@ember/controller";

export default class GroupPermissionsController extends Controller {}
